import React, {Component} from 'react';
import {TabContent, TabPane, Nav, NavItem, NavLink, Progress,
  CardColumns, Card, CardHeader, CardBody,
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem,
  Row,
  Col,
  Button,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText} from 'reactstrap';
import classnames from 'classnames';
//import ButtonDropdowns from '../../views/Buttons/ButtonDropdowns/';

class Aside extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = { collapse: true };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }
  render() {
    return (
      <aside>
        <Card>
          <CardHeader>
            Filter group 1
          </CardHeader>
          <CardBody>
            <Col xs="12">
              <FormGroup>
                <Label htmlFor="name">Name</Label>
                <Input type="text" id="name" placeholder="Enter filters word" />
              </FormGroup>
              <FormGroup>
                  <Input type="text" id="text-input" name="text-input" placeholder="Text"/>
                  <FormText color="muted">This is a help text</FormText>
              </FormGroup>
            </Col>
            <Col xs="12">
              <FormGroup>
                <Label htmlFor="ccmonth">Choose filters option</Label>
                <Input type="select" name="ccmonth" id="ccmonth">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </Input>
              </FormGroup>
            </Col>
          </CardBody>
        </Card>
        <Card>
          <CardHeader>
            Filter group 2
          </CardHeader>
          <CardBody>
            <Col xs="12">
              <FormGroup>
                <Label htmlFor="multiple-select">Multiple select</Label>
                <Input type="select" name="multiple-select" id="multiple-select" multiple>
                  <option value="1">Option #1</option>
                  <option value="2">Option #2</option>
                  <option value="3">Option #3</option>
                  <option value="4">Option #4</option>
                  <option value="5">Option #5</option>
                  <option value="6">Option #6</option>
                  <option value="7">Option #7</option>
                  <option value="8">Option #8</option>
                  <option value="9">Option #9</option>
                  <option value="10">Option #10</option>
                </Input>
              </FormGroup>
              <FormGroup>
                <Label>Radios</Label>
                <FormGroup check className="radio">
                  <Input className="form-check-input" type="radio" id="radio1" name="radios" value="option1"/>
                  <Label check className="form-check-label" htmlFor="radio1">Option 1</Label>
                </FormGroup>
                <FormGroup check className="radio">
                  <Input className="form-check-input" type="radio" id="radio2" name="radios" value="option2"/>
                  <Label check className="form-check-label" htmlFor="radio2">Option 2</Label>
                </FormGroup>
                <FormGroup check className="radio">
                  <Input className="form-check-input" type="radio" id="radio3" name="radios" value="option3"/>
                  <Label check className="form-check-label" htmlFor="radio3">Option 3</Label>
                </FormGroup>
              </FormGroup>
              <FormGroup>
                <Label>Checkboxes</Label>
                <FormGroup check className="checkbox">
                  <Input className="form-check-input" type="checkbox" id="checkbox1" name="checkbox1" value="option1"/>
                  <Label check className="form-check-label" htmlFor="checkbox1">Option 1</Label>
                </FormGroup>
                <FormGroup check className="checkbox">
                  <Input className="form-check-input" type="checkbox" id="checkbox2" name="checkbox2" value="option2"/>
                  <Label check className="form-check-label" htmlFor="checkbox2">Option 2</Label>
                </FormGroup>
                <FormGroup check className="checkbox">
                  <Input className="form-check-input" type="checkbox" id="checkbox3" name="checkbox3" value="option3"/>
                  <Label check className="form-check-label" htmlFor="checkbox3">Option 3</Label>
                </FormGroup>
              </FormGroup>
            </Col>
          </CardBody>
        </Card>
      </aside>
    )
  }
}

export default Aside;



// WEBPACK FOOTER //
// ./src/components/_Aside/Aside.js